export default __webpack_public_path__ + "static/media/faq.c769f51b.png";